export enum WarcupVotingState {
  WAITING = 'WAITING',
  VOTING = 'VOTING',
  CLOSING = 'CLOSING',
  PAUSED = 'PAUSED',
}
